/* eslint-disable camelcase */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Row } from 'reactstrap';
import { FaCheck } from 'react-icons/fa';
import LoadingButton from 'components/common/LoadingButton';
import ReactSelect from 'components/Fields/ReactSelect';
import FormikInputField from 'components/Fields/FormikInputField';
import { PlATFORM_TYPE } from 'pages/Notifications/constant';
import CardWithTitle from 'components/CardWithTitle';
import EditUploadWrapper from 'components/EditUploadWrapper';
import S3FileUploadField from 'components/S3FileUploadField';

const CustomNotificationForm = (props) => {
  const {
    handleSubmit,
    isSubmitting,
    isValid,
    dirty,
    toggleCustomNotification,
    values,
    setFieldValue,
  } = props;
  const [loading, setLoading] = React.useState(false);
  const isGifType = values?.notificationType?.id === 'GIF';
  const isImageUploadDisabled = values?.notificationType?.id !== 'GIF';

  React.useEffect(() => {
    if (!isGifType && values?.imageUrl) {
      setFieldValue('imageUrl', '');
    }
  }, [isGifType, values?.imageUrl, setFieldValue]);

  const handleCancel = (val) => {
    setFieldValue(val, '');
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle>
        <Row>
          <Col sm={12}>
            <Field
              label={
                <>
                  Title <span className="text-danger">*</span>
                </>
              }
              name="title"
              type="text"
              component={FormikInputField}
            />
          </Col>

          <Col sm={12} className="mt-3">
            <Field
              label="Platform Type"
              name="platform_type"
              type="select"
              component={ReactSelect}
              data={PlATFORM_TYPE}
              keys={{ id: 'id', label: 'label' }}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.label}
              // isDisabled
              required
            />
          </Col>
          <Col sm={12} className="mt-3">
            <Field
              label="Notification Type"
              name="notificationType"
              type="select"
              component={ReactSelect}
              data={[
                { id: 'TEXT', label: 'TEXT' },
                // {
                //   id: 'VIDEO',
                //   label: 'VIDEO',
                // },
                {
                  id: 'GIF',
                  label: 'GIF',
                },
              ]}
              keys={{ id: 'id', label: 'label' }}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.label}
              // isDisabled
              required
            />
          </Col>

          <Col sm={12} className="mt-3">
            <div
              style={
                isImageUploadDisabled
                  ? {
                    opacity: 0.55,
                    filter: 'blur(0.8px)',
                    pointerEvents: 'none',
                  }
                  : {}
              }
            >
              {values?.imageUrl ? (
                <EditUploadWrapper
                  label="Image (Optional)"
                  name="imageUrl"
                  fileName={values.imageUrl}
                  handleCancel={() => handleCancel('imageUrl')}
                />
              ) : (
                <S3FileUploadField
                  label="Image (Optional)"
                  name="imageUrl"
                  pathUrl="polystox_images/notification_image"
                  accept=".png, .jpg, .jpeg, .gif"
                  setLoading={setLoading}
                  containerName="public-assets"
                  disabled={isImageUploadDisabled}
                />
              )}
            </div>

          </Col>
          {values?.notificationType?.id === 'VIDEO' && (
            <Col sm={12} className="mt-3">
              {values?.videoUrl ? (
                <EditUploadWrapper
                  label="Video"
                  name="videoUrl"
                  fileName={values.videoUrl}
                  handleCancel={() => handleCancel('videoUrl')}
                  required
                />
              ) : (
                <S3FileUploadField
                  label="Video"
                  name="videoUrl"
                  pathUrl="polystox_images/notification_video"
                  accept=".mp4"
                  setLoading={setLoading}
                  required
                />
              )}
            </Col>
          )}
          <Col sm={12} className="mt-3">
            <Field
              label={
                <>
                  Message <span className="text-danger">*</span>
                </>
              }
              name="message"
              type="textarea"
              className="msg-field"
              component={FormikInputField}
            // placeholder="Enter Message"
            />
          </Col>
          <Col sm={12} className="mt-3">
            <div className="notification-scheduler-row">
              <div className="notification-scheduler-toggle">
                <div className="toggle-check cmn-toggle d-flex">
                  <div className="d-inline-block position-relative">
                    <input
                      id="notificationScheduler"
                      type="checkbox"
                      checked={Boolean(values?.schedulerEnabled)}
                      onChange={(event) => {
                        setFieldValue('schedulerEnabled', event.target.checked);
                        if (event.target.checked) {
                          if (!values?.scheduledAt) {
                            setFieldValue('scheduledAt', '');
                          }
                        }
                      }}
                    />
                    <FaCheck size={10} />
                  </div>
                </div>
                <label htmlFor="notificationScheduler">Schedule</label>
              </div>
              {values?.schedulerEnabled && (
                <div className="notification-scheduler-datetime">
                  <Field
                    label="Schedule Date & Time"
                    name="scheduledAt"
                    type="datetime-local"
                    component={FormikInputField}
                  />
                </div>
              )}
            </div>
          </Col>
        </Row>
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={toggleCustomNotification}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting || loading}
          color="warning"
          size="sm"
          type="submit"
        >
          {loading ? 'Uploading...' : 'Send'}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default CustomNotificationForm;
